import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import toastError from "../../../errors/toastError";
import { getSystemMailbox, setSystemMailbox } from "../../../services/emailChannel.api";

/**
 * El buzón por el que salen los correos del sistema (doc 0445 E4b): alertas del VPS, de seguridad y de
 * flujos, y la recuperación de contraseña. Elegirlo lo aplica al momento: no espera a «Guardar», así la
 * prueba de Alertas ya sale por el elegido.
 */
export default function useSystemMailbox() {
  const vivo = useRef(true);
  const [loading, setLoading] = useState(true);
  const [mailbox, setMailbox] = useState(null);
  const [candidates, setCandidates] = useState([]);
  const [saving, setSaving] = useState(false);

  const aplicar = (data) => {
    if (!vivo.current) return;
    setMailbox(data?.mailbox || null);
    setCandidates(Array.isArray(data?.candidates) ? data.candidates : []);
  };

  const refresh = useCallback(async () => {
    try {
      const { data } = await getSystemMailbox();
      aplicar(data);
    } catch (err) {
      // Sin superadmin la ruta responde 403: no hay buzón que mostrar, no es un error de la pantalla.
      if (err?.response?.status !== 403) toastError(err);
    } finally {
      if (vivo.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    vivo.current = true;
    refresh();
    return () => {
      vivo.current = false;
    };
  }, [refresh]);

  const choose = useCallback(async (whatsappId) => {
    setSaving(true);
    try {
      const { data } = await setSystemMailbox(whatsappId || null);
      aplicar(data);
      toast.success(
        data?.mailbox
          ? `Los correos del sistema saldrán desde ${data.mailbox.address}`
          : "Ninguna conexión envía ya los correos del sistema"
      );
      return true;
    } catch (err) {
      toastError(err);
      return false;
    } finally {
      if (vivo.current) setSaving(false);
    }
  }, []);

  return { loading, mailbox, candidates, saving, choose, refresh };
}
